module.exports = __webpack_public_path__ + "static/img/在线客服.14c65cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/在线客服.png
// module id = oCbS
// module chunks = 4